import { IBuyCustomPackageParams, IBuyCustomPackageSuccess, TBuyCustomPackageResult } from './types';
import {
  fetchBuyCustomPackage,
  IMappers,
} from '../../repositories/billing-service-packages-balancer/v5/buy-custom-package';
import { mapResponse200 } from './utils';
import { THeaders } from '../../types/request';
import { DEFAULT_RESULT } from './constants';

export const buyCustomPackage = async (params: IBuyCustomPackageParams): Promise<TBuyCustomPackageResult> => {
  const { httpApi, parameters } = params;

  const headers: THeaders = [['Content-Type', 'application/json']];

  const config = {
    requestConfig: { headers },
  };

  const mappers: IMappers<IBuyCustomPackageSuccess> = {
    200: mapResponse200,
  };

  try {
    const response = await fetchBuyCustomPackage({ httpApi, parameters, config, mappers });

    return response as IBuyCustomPackageSuccess;
  } catch {
    return DEFAULT_RESULT;
  }
};
